import React, { useState, useEffect } from "react";
import "./styles";
import ContainerTabs from "./styles";
import { useTheme } from "../../contexts/Theme/ThemeContext";

interface TabsProps {
  tabs: { name: string; value: string; lockedIcon?: React.ReactNode }[];
  tabsNumber?: number;
  value: string;
  onChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  tabsNumber = 3,
  value,
  onChange,
  className,
  disabled,
}) => {
  const [activeTab, setActiveTab] = useState("");
  const { theme } = useTheme();

  useEffect(() => {
    setActiveTab(value);
  }, [value]);

  return (
    <>
      <ContainerTabs className={` ${className ? className : ""}`} theme={theme}>
        <div
          className="tabs"
          style={{ gridTemplateColumns: `repeat(${tabsNumber}, 1fr)` }}
        >
          {tabs.map((tab, index) => {
            return (
              <div
                key={index}
                id={tab.value}
                className={`tab fonteSubtitulo ${tab.value === activeTab && "active-tab"}`}
                onClick={() => onChange(tab.value)}
              >
                <div className="tab-content">
                  <div className={`tab-name fonteSubtitulo`}>{tab.name}</div>
                  {tab.lockedIcon && (
                    <div className="locked-icon">{tab.lockedIcon}</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </ContainerTabs>
    </>
  );
};

export default Tabs;
